import React from "react";
import { Package } from "lucide-react";
import { OrderProductDiscrepancy } from "src/types";
import { ProductDiscrepancyTable } from "src/components/tables";
import { ProductDiscrepancyTooltip, FulfilmentRateTooltip } from "src/components/tooltips/purchaseOrdersTooltips";
import { PercentageBar } from "src/components/ui/percentageBar";

interface ReceivingDiscrepancyProductsSectionProps {
  orderProductDiscrepancies: OrderProductDiscrepancy[];
  fulfilmentRate?: number;
}

const ReceivingDiscrepancyProductsSection: React.FC<ReceivingDiscrepancyProductsSectionProps> = ({
  orderProductDiscrepancies,
  fulfilmentRate
}) => (
  <div className="border border-neutral-200 rounded-2xl p-5 bg-white">
    <h3 className="text-sm font-semibold text-black mb-4 tracking-wide uppercase flex items-center">
      <Package className="w-4 h-4 mr-2" />
      Order Products
    </h3>
    <ProductDiscrepancyTable orderProductDiscrepancies={orderProductDiscrepancies} />
    <ProductDiscrepancyTooltip />
    <div className="mt-6">
      <label className="text-sm font-medium text-gray-700 mb-2 flex items-center">
        Fulfilment Rate
        <FulfilmentRateTooltip />
      </label>
      <PercentageBar percentage={fulfilmentRate ?? 0} width="65%" />
    </div>
  </div>
);

export { ReceivingDiscrepancyProductsSection };
